import { useIntl } from 'react-intl';
import { useState } from 'react'
import {  Button, Form, Input, Divider, notification, Checkbox } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const PasswordPage = (props) => {  

    const [state, setState] = useState({
        do_not_use: !props.credentials.IsHTTPAuthorizationEnabled,
    });

    const intl = useIntl();

    function onFinish(values) {

        if (values["new_password"] !== values["confirm_new_password"])
        {
            notification['error']({
                message: intl.formatMessage({id: 'Error'}),
                description: intl.formatMessage({id: 'PasswordsMismatch'}),
                duration: 0
              });

            return;
        }

        props.onSubmit(values);
      };

    function onFinishFailed(errorInfo) {
        console.log('Failed:', errorInfo);
      };

    function onFieldsChange(changedFields, allFields)
    {
        if (changedFields.length > 0)
        {
            var do_not_use = allFields[0].value;

            setState({...state, do_not_use: do_not_use});
        }
    }
    
    return (
        <div>
            <br/>
            <Form
                name="basic"
                labelCol={{
                    span: 8,
                }}            
                wrapperCol={{
                    span: 12,
                }}
                style={{
                    maxWidth: 600,
                }}
                initialValues={{
                    do_not_use: !props.credentials.IsHTTPAuthorizationEnabled,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onFieldsChange={onFieldsChange}
                autoComplete="off"
            >
                <Form.Item 
                    wrapperCol={{
                        offset: 0,
                        span: 12,
                    }}
                    name="do_not_use" valuePropName="checked">
                    <Checkbox>{intl.formatMessage({id: 'DontUseWebAuth'})}</Checkbox>
                </Form.Item>

                {props.credentials.IsHTTPAuthorizationEnabled &&
                    <Form.Item
                    label={intl.formatMessage({id: 'CurrentUsername'})}
                    name="username"
                    rules={[
                        {
                        required: true,
                        message: intl.formatMessage({id: 'Username_empty'}),
                        },
                    ]}
                    >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />}/>
                    </Form.Item>
                }

                {props.credentials.IsHTTPAuthorizationEnabled &&
                    <Form.Item
                    label={intl.formatMessage({id: 'CurrentPassword'})}
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: intl.formatMessage({id: 'Password_empty'}),
                        },
                    ]}
                    >
                    <Input.Password prefix={<LockOutlined className="site-form-item-icon"/>}/>
                    </Form.Item>
                }

                {props.credentials.IsHTTPAuthorizationEnabled && <Divider/>}

                <Form.Item
                label={intl.formatMessage({id: 'NewUsername'})}
                name="new_username"
                rules={[
                    {
                    required: !state.do_not_use,
                    message: intl.formatMessage({id: 'Username_empty'}),
                    },
                ]}
                >
                <Input disabled = {state.do_not_use} prefix={<UserOutlined className="site-form-item-icon" />}/>
                </Form.Item>

                <Form.Item
                label={intl.formatMessage({id: 'NewPassword'})}
                name="new_password"
                rules={[
                    {
                        required: !state.do_not_use,
                        message: intl.formatMessage({id: 'Password_empty'}),
                    },
                ]}
                >
                <Input.Password disabled = {state.do_not_use} prefix={<LockOutlined className="site-form-item-icon"/>}/>
                </Form.Item>

                <Form.Item
                label={intl.formatMessage({id: 'ConfirmPassword'})}
                name="confirm_new_password"
                rules={[
                    {
                        required: !state.do_not_use,
                        message: intl.formatMessage({id: 'Password_empty'}),
                    },
                ]}
                >
                <Input.Password disabled = {state.do_not_use} prefix={<LockOutlined className="site-form-item-icon"/>}/>
                </Form.Item>

                <Form.Item
                wrapperCol={{
                    offset: 6,
                    span: 6,
                }}
                >
                <Button type="primary" htmlType="submit">
                    Submit
                </Button>
                </Form.Item>
            </Form>
        </div>
    );   
}
  
export default PasswordPage;